<template>
  <main>
    <form @submit.prevent="register">
      <div class="input-group">
        <label for="name">Name:</label>
        <input id="name" type="text" v-model="name" required />
        <p>
          <em>{{ errors.name }}</em>
        </p>
      </div>

      <div class="input-group">
        <label for="email">Email:</label>
        <input id="email" type="email" v-model="email" required />
        <p>
          <em>{{ errors.email }}</em>
        </p>
      </div>

      <div class="input-group">
        <label for="password">Password:</label>
        <input id="password" type="password" v-model="password" required />
        <p>
          <em>{{ errors.password }}</em>
        </p>
      </div>

      <button type="submit">Register</button>
    </form>
  </main>
</template>

<script>
export default {
  name: 'register',

  data() {
    return {
      name: '',
      email: '',
      password: '',
      errors: {
        name: '',
        email: '',
        password: '',
      },
    };
  },

  methods: {
    async register() {
      const name = this.name;
      const email = this.email;
      const password = this.password;

      this.errors = {
        name: '',
        email: '',
        password: '',
      };

      try {
        await this.$http.put('/auth/register', {
          name,
          email,
          password,
        });
      } catch ({ response }) {
        if (response.status === 422) {
          const errors = response.data.errors;

          for (const key in errors) {
            const message = errors[key].join('\n');

            switch (key.toLowerCase()) {
              case 'name':
                this.errors.name = message;
                break;
              case 'email':
                this.errors.email = message;
                break;
              case 'password':
                this.errors.password = message;
                break;
            }
          }
        }

        return;
      }

      this.$router.push({ name: 'login' });
    },
  },
};
</script>
